import {
	Component,
	Injector,
} from '@angular/core';

import {
	NgForm,
	UntypedFormControl,
} from '@angular/forms';

import { finalize } from 'rxjs/operators';

import { CommonBaseComponent } from '../../../Common/components/base.component';

import { AuthenticationMeetingsUserService, IAuthenticationMeetingsUserActionsResponse } from '../authentication/services/authentication.meetings.user.service';
import { AuthenticationMeetingsErrorService } from '../authentication/services/authentication.meetings.error.service';
import { MeetingsAuthAnimation } from '../animation/animation';
import { IAuthenticationMeetingsRemindUser } from '../authentication/authentication.interfaces';

@Component({
	selector: 'authentication-meetings-remind',
	templateUrl: './authentication.meetings.remind.component.pug',
	animations: [
		MeetingsAuthAnimation,
	],
})
export class AuthenticationMeetingsRemindComponent extends CommonBaseComponent {
	state = {
		isLoading: false,
		isReminded: false,
	};

	data: IAuthenticationMeetingsRemindUser = {
		Email: '',
	};

	resource = {
		validationCustomErrors: {
			custom: '',
		},
	};

	onChangeFieldHandler = this.authenticationMeetingsErrorService.onChangeFieldHandler;

	constructor (
		protected injector: Injector,
		private authenticationMeetingsUserService: AuthenticationMeetingsUserService,
		private authenticationMeetingsErrorService: AuthenticationMeetingsErrorService,
	) {
		super(injector);
	}

	remind (form: NgForm) {
		if (form.valid) {
			this.state.isLoading = true;

			this.authenticationMeetingsUserService
				.resetPassword(this.data)
				.pipe(
					finalize(() => this.state.isLoading = false),
				)
				.subscribe((response: IAuthenticationMeetingsUserActionsResponse) => {
					if (response.IsSuccess) {
						this.state.isReminded = true;
					} else {
						this.authenticationMeetingsErrorService.handleSuccessResponse(response, this.resource.validationCustomErrors, form.controls.email as UntypedFormControl);
					}
				});
		}
	}
}
